export const RESTRICTION_CHAT = {
  checkForLength: false,
  messageLength: 500,
};

export const documentTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx',
  '.txt',
  '.rtf',
  '.odt',
  '.ods',
  '.odp',
];

export const pdfTypes = ['application/pdf', '.pdf'];

export const imageTypes = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/bmp',
  'image/tiff',
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.bmp',
  '.tiff',
];

export const audioTypes = ['audio/mpeg', 'audio/wav', 'audio/aac', 'audio/vnd.dlna.adts', '.mp3', '.wav', '.aac'];

export const videoTypes = [
  'video/mp4',
  'video/x-msvideo',
  'video/quicktime',
  'video/x-ms-wmv',
  'video/x-matroska',
  'video/avi',
  '.mp4',
  '.avi',
  '.mov',
  '.wmv',
  '.mkv',
];

export const compressedTypes = [
  'application/zip',
  'application/vnd.rar',
  'application/x-7z-compressed',
  '.zip',
  '.rar',
  '.7z',
];

export const otherTypes = ['text/csv', 'text/html', 'application/vnd.visio', '.csv', '.html', '.htm', '.vsd', '.vsdx'];

export const allowedTypes = [
  ...documentTypes,
  ...pdfTypes,
  ...imageTypes,
  ...audioTypes,
  ...videoTypes,
  ...compressedTypes,
  ...otherTypes,
];

export const allowedTypesToView = [
  'image/jpeg',
  '.jpeg',
  'image/png',
  '.png',
  'image/gif',
  '.gif',
  'image/bmp',
  '.bmp',
  '.jpg',
  'application/pdf',
  '.pdf',
  'text/plain',
  '.txt',
];

// Blocked file extensions for security reasons
export const blockedExtensions = ['exe', 'bat', 'msi', 'js', 'vbs', 'xlsm', 'docm'];
